import {ReactElement} from 'react';

import {LoadingCellRendererProps} from './LoadingCellRendererProps';

export type LoadingCellRenderer = (props: LoadingCellRendererProps) => ReactElement | null;
